import { Icon, IconWarning } from '@procurify/ui'

import {
  type CatalogItemTagIcon,
  CatalogItemTagIcons,
} from '../../value-objects/CatalogItemTag'

export interface ICatalogItemTagGlyphProps {
  icon: CatalogItemTagIcon
  size: number
}

export const CatalogItemTagGlyph = ({
  icon,
  size,
}: ICatalogItemTagGlyphProps) => {
  if (icon === CatalogItemTagIcons.WARNING) {
    return <IconWarning size={size} />
  }
  return <Icon icon={icon} size={size} />
}
